import { Button, Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Languages } from '~/constants/enums';
import { TOP_SELLER_LEAD_CACHE_KEY } from '~/pages/LeadFollowUp/utils';
import { usePostTopSellerLeadMutation } from '~/redux/api/appApiSlice';
import { TopSellerLeadEventParams } from '~/types/topSellersTypes';
import { sendGTMEvent } from '~/utils';

export default function RequestCallButton({
  leadId,
  hash,
  sellers,
}: {
  leadId: string;
  // Forwarded exactly as it arrived on the landing-page link: it is the only
  // thing authorizing the request, so it must not be re-encoded or trimmed.
  hash: string;
  sellers: number[];
}) {
  const { t, i18n } = useTranslation('app');
  const [postTopSellerLead, { isLoading, isSuccess }] =
    usePostTopSellerLeadMutation({
      fixedCacheKey: TOP_SELLER_LEAD_CACHE_KEY,
    });

  const handleRequestCall = async () => {
    const topSellerLeadParams: TopSellerLeadEventParams = {
      lead_source_page: 'lead-follow-up',
      leads_count: String(sellers.length),
    };
    sendGTMEvent({
      event: 'gtm-top_seller_lead_click',
      ...topSellerLeadParams,
    });
    const result = await postTopSellerLead({ leadId, hash, sellers });
    if (!('data' in result)) return;
    sendGTMEvent({
      event: 'gtm-top_seller_lead_success',
      ...topSellerLeadParams,
    });
  };

  return (
    <Button
      ariaLabel="request-call"
      variant="primary"
      size="medium"
      className="w-full md:w-fit"
      disabled={isSuccess}
      isLoading={isLoading}
      Icon={
        <Icon
          name={isSuccess ? 'check' : 'phone'}
          size="24px"
          className={
            !isSuccess && i18n.language === Languages.ENGLISH
              ? 'scale-x-[-1]'
              : ''
          }
        />
      }
      onClick={handleRequestCall}
    >
      {t(isSuccess ? 'leadFollowUpCallRequested' : 'leadFollowUpRequestCall')}
    </Button>
  );
}
